
import totalLocationData, { ClassInfo } from "./locationdata";
import { ReactComponent as SunbaeWhiteLogo } from "../svg/newlogowhite.svg";
import { ReactComponent as MomWhiteLogo } from "../svg/logo/mom/whitelogo.svg";
import { ReactComponent as SunbaeShapeLogo } from "../svg/onlyshape.svg";
import { ReactComponent as MomShapeLogo } from "../svg/logo/mom/just.svg";
import { ReactComponent as MomShapeLogo2 } from "../svg/logo/mom/just2.svg";
import { ReactComponent as SunbaeLogo } from "../svg/newlogo.svg";
import { ReactComponent as MomLogo } from "../svg/logo/mom/logo.svg";
import { ReactComponent as MolipLogo } from "../svg/logo/molip/logo.svg";
import { ReactComponent as MolipWhiteLogo } from "../svg/logo/molip/whitelogo.svg";
import { ReactComponent as MolipShapeLogo } from "../svg/logo/molip/just.svg";
import { ReactComponent as UbaseLogo } from "../svg/logo/ubase/logo.svg";
import { ReactComponent as UbaseWhiteLogo } from "../svg/logo/ubase/whitelogo.svg";
import { ReactComponent as UbaseShapeLogo } from "../svg/logo/ubase/just.svg";
import { ReactComponent as AlltargetLogo } from "../svg/logo/alltarget/logo.svg";
import { ReactComponent as AlltargetWhiteLogo } from "../svg/logo/alltarget/whitelogo.svg";
import { ReactComponent as AlltargetShapeLogo } from "../svg/logo/alltarget/just.svg";
import { ReactComponent as SunbaeShaLogo } from "../svg/logo/sunbaesha/logo.svg";
import { ReactComponent as SunbaeShaWhiteLogo } from "../svg/logo/sunbaesha/whitelogo.svg";
import { ReactComponent as SunbaeShaShapeLogo } from "../svg/logo/sunbaesha/just.svg";
import { ReactComponent as LionLogo } from "../svg/logo/lion/Black.svg";
import { ReactComponent as LionWhiteLogo } from "../svg/logo/lion/whitelogo.svg";
import { ReactComponent as LionShapeLogo } from "../svg/logo/lion/just.svg";

import styles from "../dashboard/dashboard.module.css";

interface PatrolTime {
    class: number;
    time: string[];
}

export const returnAccountInfo = (academy: string) => {

    const accounts: any = {
        sunbae: {
            bank: "신한은행",
            account: "110-238-365349",
            name: "고용범"
        },
        mom: {
            bank: "신한은행",
            account: "110-150-796744",
            name: "강수아"
        },
        bundangsunbae: {
            bank: "신한은행",
            account: "110-238-365349",
            name: "고용범"
        },
        ubase: {
            bank: "기업은행",
            account: "310-103650-02-011",
            name: "윤희상"
        },
        sunbaesha: {
            bank: "신한은행",
            account: "140-015-515117",
            name: "수능선배 샤학관 수성구점"
        },
        lion: {
            bank: "신한은행",
            account: "110-238-365349",
            name: "고용범"
        }
    }

    return accounts[academy];

}

export const koreanLocationToEnglish = (koreanLocation: string) => {

    const location = totalLocationData.find((location) => location.korean === koreanLocation);

    if (location) {
        return location.english;
    }

}

export const englishLocationToKorean = (englishLocation: string) => {

    const location = totalLocationData.find((location) => location.english === englishLocation);

    if (location) {
        return location.korean;
    }

}

export const renderSeatSvg = (where: string, user: any) => {


    const Location: any = totalLocationData.find((location) => location.english === where);

    if (Location) {
        return <Location.seatSvg user={user} />;
    }

}

// 좌석번호 범위 기반 남녀석 배경색 매핑.
// (송파/대구/신촌은 SVG 파일에 색이 박혀 있어 여기 넣지 않는다 → 중복/충돌 방지)
export const genderSeatColorMap: {
    [location: string]: { female: number[][]; male: number[][] };
} = {
    daechi: { female: [[5, 28]], male: [[29, 56]] },
    daechi2: { female: [[137, 164]], male: [[111, 136]] },
    daechi3: { female: [[211, 236]], male: [[237, 252]] },
    gimpo: { female: [[92, 116], [146, 177]], male: [[69, 91], [117, 145]] },
    bundang: { female: [[49, 108]], male: [[19, 48], [109, 132]] },
};

// 해당 지점/좌석번호의 배경색을 반환. 대상이 아니면 null(=기본 회색 유지).
export const getGenderSeatColor = (location: string, seatNumber: number): string | null => {

    const config = genderSeatColorMap[location];

    if (!config) {
        return null;
    }

    const inRange = (ranges: number[][]) => ranges.some(([a, b]) => seatNumber >= a && seatNumber <= b);

    if (inRange(config.female)) {
        return "#ffd8d7"; // 여자석 핑크
    }

    if (inRange(config.male)) {
        return "#dbe8ff"; // 남자석 파랑
    }

    return null;

}

export const renderLogoSvg = (academy: string, kind: "logo" | "shape" | "white", className?: string, number = 0
) => {

    var newKind: any = kind;

    if (number) {
        newKind = newKind + number;
    }


    const logoInfos = [
        { academy: "sunbae", white: SunbaeWhiteLogo, shape: SunbaeShapeLogo, logo: SunbaeLogo },
        { academy: "mom", white: MomWhiteLogo, shape: MomShapeLogo, logo: MomLogo, shape2: MomShapeLogo2 },
        { academy: "molip", white: MolipWhiteLogo, shape: MolipShapeLogo, logo: MolipLogo },
        { academy: "bundangsunbae", white: SunbaeWhiteLogo, shape: SunbaeShapeLogo, logo: SunbaeLogo },
        { academy: "ubase", white: UbaseWhiteLogo, shape: UbaseShapeLogo, logo: UbaseLogo },
        { academy: "alltarget", white: AlltargetWhiteLogo, shape: AlltargetShapeLogo, logo: AlltargetLogo },
        { academy: "sunbaesha", white: SunbaeShaWhiteLogo, shape: SunbaeShaShapeLogo, logo: SunbaeShaLogo },
        { academy: "lion", white: LionWhiteLogo, shape: LionShapeLogo, logo: LionLogo },
    ]

    const LogoInfo: any = logoInfos.find((info) => info.academy === academy);

    if (LogoInfo) {
        const LogoComponent = LogoInfo[newKind];
        return <LogoComponent className={className} />
    }


}

export const englishAcademyNameToKorean = (englishName: string) => {

    const academyNames = [
        { english: "sunbae", korean: "수능선배" },
        { english: "mom", korean: "김엄마" },
        { english: "molip", korean: "몰입공간" },
        { english: "bundangsunbae", korean: "수능선배" },
        { english: "ubase", korean: "유베이스" },
        { english: "alltarget", korean: "올타겟" },
        { english: "sunbaesha", korean: "수능선배" },
        { english: "lion", korean: "사자" },
    ]

    const academy = academyNames.find((name) => name.english === englishName);

    if (academy) {
        return academy.korean;
    }

}

export const returnLocationClassInfo = (location: string): ClassInfo[] => {

    var classInfo: ClassInfo[] | undefined;

    totalLocationData.forEach((locationData) => {

        if (locationData.english === location) {
            classInfo = locationData.classInfo;
        }

    });

    if (!classInfo) {
        return [{
            classNumber: "fourth",
            start: {
                hours: 11,
                minutes: 0
            },
            end: {
                hours: 12,
                minutes: 0
            }

        }]
    }

    return classInfo;

}

export interface classInfoTimeInfo {
    firstTime: number;
    lastTime: number;
    saturedayLastTime: number;
}

export const returnFirstLastTime = (location: string): classInfoTimeInfo => {

    var result = {
        firstTime: 0,
        lastTime: 0,
        saturedayLastTime: 0
    }

    var classInfo: ClassInfo[] | undefined;

    totalLocationData.forEach((locationData) => {

        if (locationData.english === location) {
            classInfo = locationData.classInfo;
        }

    });

    if (!classInfo) {
        return result;
    }

    classInfo.forEach((info) => {

        if (info.isFirst) {
            const time = info.start.hours * 60 + info.start.minutes;
            result.firstTime = time;
        }

        if (info.isLast) {

            const time = info.end.hours * 60 + info.end.minutes;
            result.lastTime = time;
            result.saturedayLastTime = time;
        }

    });

    classInfo.forEach((info) => {

        if (info.isSaturedayLast) {

            const time = info.end.hours * 60 + info.end.minutes;
            result.saturedayLastTime = time;

        }

    });


    return result;

}

export const returnPatrolTime = (academy: string) => {

    if (!academy) {
        return [];
    }

    const classDatas: Record<string, PatrolTime[]> = {
        sunbae: [
            {
                class: 1,
                time: ["8:00", "8:20", "8:40"]
            },
            {
                class: 2,
                time: ["9:00", "9:20", "9:40", "10:00"]
            },
            {
                class: 3,
                time: ["10:30", "10:50", "11:10", "11:30"]
            },
            {
                class: 4,
                time: ["13:00", "13:20", "13:40", "14:00"]
            },
            {
                class: 5,
                time: ["14:30", "14:50", "15:10", "15:30"]
            },
            {
                class: 6,
                time: ["16:00", "16:20", "16:40", "17:00"]
            },
            {
                class: 7,
                time: ["18:30", "18:50", "19:10"]
            },
            {
                class: 8,
                time: ["19:45", "20:05", "20:25"]
            },
            {
                class: 9,
                time: ["21:00", "21:20", "21:40"]
            },
        ],
        mom: [
            {
                class: 1,
                time: ["8:00", "8:20", "8:40"]
            },
            {
                class: 2,
                time: ["9:00", "9:20", "9:40", "10:00"]
            },
            {
                class: 3,
                time: ["10:20", "10:40", "11:00", "11:20", "11:40"]
            },
            {
                class: 4,
                time: ["13:00", "13:20", "13:40", "14:00"]
            },
            {
                class: 5,
                time: ["14:20", "14:40", "15:00", "15:20", "15:40"]
            },
            {
                class: 6,
                time: ["16:00", "16:20", "16:40"]
            },
            {
                class: 7,
                time: ["17:00", "17:20", "17:40"]
            },
            {
                class: 8,
                time: ["19:00", "19:20", "19:40", "20:00"]
            },
            {
                class: 9,
                time: ["20:20", "20:40", "21:00"]
            },
            {
                class: 10,
                time: ["21:20", "21:40", "22:00"]
            },
            {
                class: 11,
                time: ["22:20", "22:40", "23:00"]
            },
            {
                class: 12,
                time: ["23:20", "23:40"]
            }
        ],
        molip: [
            {
                class: 1,
                time: ["9:00", "9:30", "10:00"]
            },
            {
                class: 2,
                time: ["10:40", "11:10", "11:40"]
            },
            {
                class: 3,
                time: ["13:10", "13:40", "14:10"]
            },
            {
                class: 4,
                time: ["14:50", "15:20", "15:50"]
            },
            {
                class: 5,
                time: ["16:30", "17:00", "17:30"]
            },
            {
                class: 6,
                time: ["19:00", "19:30", "20:00"]
            },
            {
                class: 7,
                time: ["20:40", "21:10", "21:40"]
            }
        ],
        bundangsunbae: [
            {
                class: 1,
                time: ["8:00", "8:20", "8:40"]
            },
            {
                class: 2,
                time: ["9:00", "9:20", "9:40", "10:00"]
            },
            {
                class: 3,
                time: ["10:30", "10:50", "11:10", "11:30"]
            },
            {
                class: 4,
                time: ["13:00", "13:20", "13:40", "14:00"]
            },
            {
                class: 5,
                time: ["14:30", "14:50", "15:10", "15:30"]
            },
            {
                class: 6,
                time: ["16:00", "16:20", "16:40", "17:00"]
            },
            {
                class: 7,
                time: ["18:30", "18:50", "19:10"]
            },
            {
                class: 8,
                time: ["19:45", "20:05", "20:25"]
            },
            {
                class: 9,
                time: ["21:00", "21:20", "21:40"]
            },
        ],
        //         ubase 순찰 정보
        //         1교시 08:00-09:00 (08:10, 08:40 2회) 
        // 2교시 09:20-10:40 (09:30, 10:00, 10:20 3회) 
        // 3교시 11:00 - 12:10 (11:10, 11:40 2회)
        // 4교시 13:30-14:50 (13:40, 14:10, 14:30 3회) 
        // 5교시 15:10-16:30 (15:20, 15:50, 16:10 3회) 
        // 6교시 16:50 - 18:00 (17:00, 17:30 2회) 
        // 7교기 19:10-20:30 (19:20, 19:50, 20:20 3회) 
        // 8교시 20:50 - 22:00 (21:00, 21:30 2회) 
        ubase: [
            {
                class: 1,
                time: ["8:10", "8:40"]
            },
            {
                class: 2,
                time: ["9:30", "10:00", "10:20"]
            },
            {
                class: 3,
                time: ["11:10", "11:40"]
            },
            {
                class: 4,
                time: ["13:40", "14:10", "14:30"]
            },
            {
                class: 5,
                time: ["15:20", "15:50", "16:10"]
            },
            {
                class: 6,
                time: ["17:00", "17:30"]
            },
            {
                class: 7,
                time: ["19:20", "19:50", "20:20"]
            },
            {
                class: 8,
                time: ["21:00", "21:30"]
            }
        ],
        alltarget: [
            {
                class: 0,
                time: ["8:00"]
            },
            {
                class: 1,
                time: ["8:30", "9:00"]
            },
            {
                class: 2,
                time: ["9:30", "10:00"]
            },
            {
                class: 3,
                time: ["10:30", "11:00", "11:30", "12:00"]
            },
            {
                class: 4,
                time: ["13:10", "13:40", "14:10"]
            },
            {
                class: 5,
                time: ["14:45", "15:15", "15:45"]
            },
            {
                class: 6,
                time: ["16:30", "17:00"]
            },
            {
                class: 7,
                time: ["18:30", "19:00", "19:30"]
            },
            {
                class: 8,
                time: ["20:05", "20:35", "21:05"]
            },
            {
                class: 9,
                time: ["21:40", "22:10"]
            },
            {
                class: 10,
                time: ["22:50", "23:20"]
            }
        ],
        sunbaesha: [
            {
                class: 1,
                time: ["8:00", "8:20", "8:40"]
            },
            {
                class: 2,
                time: ["9:00", "9:20", "9:40", "10:00"]
            },
            {
                class: 3,
                time: ["10:30", "10:50", "11:10", "11:30"]
            },
            {
                class: 4,
                time: ["13:00", "13:20", "13:40", "14:00"]
            },
            {
                class: 5,
                time: ["14:30", "14:50", "15:10", "15:30"]
            },
            {
                class: 6,
                time: ["16:00", "16:20", "16:40", "17:00"]
            },
            {
                class: 7,
                time: ["18:30", "18:50", "19:10"]
            },
            {
                class: 8,
                time: ["19:45", "20:05", "20:25"]
            },
            {
                class: 9,
                time: ["21:00", "21:20", "21:40"]
            },
        ],
        lion: [
            { class: 1, time: ["09:00", "09:20", "09:40"] },
            { class: 2, time: ["10:00", "10:20", "10:40"] },
            { class: 3, time: ["11:00", "11:20", "11:40"] },
            { class: 4, time: ["12:00", "12:20", "12:40"] },
            { class: 5, time: ["13:00", "13:20", "13:40"] },
            { class: 6, time: ["14:00", "14:20", "14:40"] },
            { class: 7, time: ["15:00", "15:20", "15:40"] },
            { class: 8, time: ["16:00", "16:20", "16:40"] },
            { class: 9, time: ["17:00", "17:20", "17:40"] },
            { class: 10, time: ["18:00", "18:20", "18:40"] },
            { class: 11, time: ["19:00", "19:20", "19:40"] },
            { class: 12, time: ["20:00", "20:20", "20:40"] },
            { class: 13, time: ["21:00", "21:20", "21:40"] },
            { class: 14, time: ["22:00", "22:20", "22:40"] },
            { class: 15, time: ["23:00", "23:20", "23:40"] },
        ]

    }

    const patrolTime = classDatas[academy];

    if (!patrolTime) {
        return [];
    }

    return patrolTime;

}

export const dayNumberToKorean = (dayNumber: number) => {

    const dayNames = ["일", "월", "화", "수", "목", "금", "토"];

    return dayNames[dayNumber];

}

export const returnNeedAuthorizeAcademy = () => {

    const list = ["sunbae"];

    return list;

}

export const returnAuthorizedJob = (academy: string) => {

    const job = ["desk", "etc", "manager", "sagam", "duty"];

    return job;

}